import { exampleContentLang, findResumeExample, type ResumeExampleEntry } from '~/constants/resumeExamples'

/**
 * Lazy loaders for data/resume-examples/<slug>.json and its Czech and German
 * translations in data/resume-examples/cs and /de, so a page ships only its own
 * example. German falls back to English where there is no translation yet.
 * The index in constants/resumeExamples.ts decides which slugs exist; a file
 * that is not indexed is never loaded.
 *
 * App-side only: Nitro does not bundle `import.meta.glob`, which is why the
 * server has its own static map in server/utils/resumeExamples.ts.
 */
const entries = import.meta.glob<{ default: ResumeExampleEntry }>('../data/resume-examples/**/*.json')

export async function loadResumeExampleEntry(slug: unknown, lang = 'en'): Promise<ResumeExampleEntry | null> {
  const item = findResumeExample(slug)
  const contentLang = item ? exampleContentLang(item, lang) : null
  const dir = contentLang ? `${contentLang}/` : ''
  const loader = item ? entries[`../data/resume-examples/${dir}${item.slug}.json`] : undefined
  return loader ? (await loader()).default : null
}
